import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'cityads-v3/types/reducer';

import Box from '@mui/material/Box'
import MenuBottomLinks from './MenuBottomLinks';
import MenuContentGuest from './MenuContentGuest';
import MenuContentUser from './MenuContentUser';

export default function MenuContent(): JSX.Element {
  const isLoggedIn = useSelector((state: RootState) => state.auth.isLoggedIn)
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <Box
        sx={{ flexGrow: '1' }}
      >
        {isLoggedIn ? <MenuContentUser /> : <MenuContentGuest />}
      </Box>
      <MenuBottomLinks />
    </Box>
  )
}
